/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as authenticatedRouteImport } from './routes/(authenticated)/route'
import { Route as IndexImport } from './routes/index'
import { Route as AuthIndexImport } from './routes/auth/index'
import { Route as AuthCompleteImport } from './routes/auth/complete'
import { Route as authenticatedLeadsRouteImport } from './routes/(authenticated)/leads/route'
import { Route as authenticatedCarsRouteImport } from './routes/(authenticated)/cars/route'
import { Route as authenticatedTradesIndexImport } from './routes/(authenticated)/trades/index'
import { Route as authenticatedTasksIndexImport } from './routes/(authenticated)/tasks/index'
import { Route as authenticatedProfileIndexImport } from './routes/(authenticated)/profile/index'
import { Route as authenticatedMyTasksIndexImport } from './routes/(authenticated)/my-tasks/index'
import { Route as authenticatedHotkeysIndexImport } from './routes/(authenticated)/hotkeys/index'
import { Route as authenticatedConnectionsIndexImport } from './routes/(authenticated)/connections/index'
import { Route as authenticatedComponentsIndexImport } from './routes/(authenticated)/components/index'
import { Route as authenticatedAppraisalsIndexImport } from './routes/(authenticated)/appraisals/index'
import { Route as authenticatedAboutIndexImport } from './routes/(authenticated)/about/index'
import { Route as authenticatedTradeShortIdIndexImport } from './routes/(authenticated)/trade/$shortId/index'
import { Route as authenticatedCarsSoldIndexImport } from './routes/(authenticated)/cars/sold/index'
import { Route as authenticatedCarsPendingIndexImport } from './routes/(authenticated)/cars/pending/index'
import { Route as authenticatedCarsAvailableIndexImport } from './routes/(authenticated)/cars/available/index'
import { Route as authenticatedCarsAllIndexImport } from './routes/(authenticated)/cars/all/index'
import { Route as authenticatedCarsListingIdIndexImport } from './routes/(authenticated)/cars/$listingId/index'
import { Route as authenticatedAppraisalsAppraisalIdIndexImport } from './routes/(authenticated)/appraisals/$appraisalId/index'
import { Route as authenticatedHubMyDealsIndexImport } from './routes/(authenticated)/$hub/my-deals/index'
import { Route as authenticatedHubMyDealsBoardIndexImport } from './routes/(authenticated)/$hub/my-deals-board/index'
import { Route as authenticatedHubLogbookIndexImport } from './routes/(authenticated)/$hub/logbook/index'
import { Route as authenticatedHubInboxIndexImport } from './routes/(authenticated)/$hub/inbox/index'
import { Route as authenticatedHubDeliveryQueueIndexImport } from './routes/(authenticated)/$hub/delivery-queue/index'
import { Route as authenticatedHubDealsIndexImport } from './routes/(authenticated)/$hub/deals/index'
import { Route as authenticatedHubContractStatusIndexImport } from './routes/(authenticated)/$hub/contract-status/index'
import { Route as authenticatedHubContractQueueIndexImport } from './routes/(authenticated)/$hub/contract-queue/index'
import { Route as authenticatedHubBoardIndexImport } from './routes/(authenticated)/$hub/board/index'
import { Route as authenticatedHubArchivedDealsIndexImport } from './routes/(authenticated)/$hub/archived-deals/index'
import { Route as authenticatedHubAllIndexImport } from './routes/(authenticated)/$hub/all/index'
import { Route as ApiAuthCallbackSlackIndexImport } from './routes/api/auth/callback/slack/index'
import { Route as authenticatedTradeShortIdTitleIndexImport } from './routes/(authenticated)/trade/$shortId/$title/index'
import { Route as authenticatedHubDealShortIdIndexImport } from './routes/(authenticated)/$hub/deal/$shortId/index'
import { Route as authenticatedHubDealShortIdTitleIndexImport } from './routes/(authenticated)/$hub/deal/$shortId/$title/index'

// Create/Update Routes

const authenticatedRouteRoute = authenticatedRouteImport.update({
  id: '/(authenticated)',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRoute,
} as any)

const AuthCompleteRoute = AuthCompleteImport.update({
  id: '/auth/complete',
  path: '/auth/complete',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedLeadsRouteRoute = authenticatedLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedCarsRouteRoute = authenticatedCarsRouteImport.update({
  id: '/cars',
  path: '/cars',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedTradesIndexRoute = authenticatedTradesIndexImport.update({
  id: '/trades/',
  path: '/trades/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedTasksIndexRoute = authenticatedTasksIndexImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedProfileIndexRoute = authenticatedProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedMyTasksIndexRoute = authenticatedMyTasksIndexImport.update({
  id: '/my-tasks/',
  path: '/my-tasks/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedHotkeysIndexRoute = authenticatedHotkeysIndexImport.update({
  id: '/hotkeys/',
  path: '/hotkeys/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedConnectionsIndexRoute =
  authenticatedConnectionsIndexImport.update({
    id: '/connections/',
    path: '/connections/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedComponentsIndexRoute =
  authenticatedComponentsIndexImport.update({
    id: '/components/',
    path: '/components/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedAppraisalsIndexRoute =
  authenticatedAppraisalsIndexImport.update({
    id: '/appraisals/',
    path: '/appraisals/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedAboutIndexRoute = authenticatedAboutIndexImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedTradeShortIdIndexRoute =
  authenticatedTradeShortIdIndexImport.update({
    id: '/trade/$shortId/',
    path: '/trade/$shortId/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedCarsSoldIndexRoute = authenticatedCarsSoldIndexImport.update(
  {
    id: '/sold/',
    path: '/sold/',
    getParentRoute: () => authenticatedCarsRouteRoute,
  } as any,
)

const authenticatedCarsPendingIndexRoute =
  authenticatedCarsPendingIndexImport.update({
    id: '/pending/',
    path: '/pending/',
    getParentRoute: () => authenticatedCarsRouteRoute,
  } as any)

const authenticatedCarsAvailableIndexRoute =
  authenticatedCarsAvailableIndexImport.update({
    id: '/available/',
    path: '/available/',
    getParentRoute: () => authenticatedCarsRouteRoute,
  } as any)

const authenticatedCarsAllIndexRoute = authenticatedCarsAllIndexImport.update({
  id: '/all/',
  path: '/all/',
  getParentRoute: () => authenticatedCarsRouteRoute,
} as any)

const authenticatedCarsListingIdIndexRoute =
  authenticatedCarsListingIdIndexImport.update({
    id: '/$listingId/',
    path: '/$listingId/',
    getParentRoute: () => authenticatedCarsRouteRoute,
  } as any)

const authenticatedAppraisalsAppraisalIdIndexRoute =
  authenticatedAppraisalsAppraisalIdIndexImport.update({
    id: '/appraisals/$appraisalId/',
    path: '/appraisals/$appraisalId/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubMyDealsIndexRoute =
  authenticatedHubMyDealsIndexImport.update({
    id: '/$hub/my-deals/',
    path: '/$hub/my-deals/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubMyDealsBoardIndexRoute =
  authenticatedHubMyDealsBoardIndexImport.update({
    id: '/$hub/my-deals-board/',
    path: '/$hub/my-deals-board/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubLogbookIndexRoute =
  authenticatedHubLogbookIndexImport.update({
    id: '/$hub/logbook/',
    path: '/$hub/logbook/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubInboxIndexRoute = authenticatedHubInboxIndexImport.update(
  {
    id: '/$hub/inbox/',
    path: '/$hub/inbox/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any,
)

const authenticatedHubDeliveryQueueIndexRoute =
  authenticatedHubDeliveryQueueIndexImport.update({
    id: '/$hub/delivery-queue/',
    path: '/$hub/delivery-queue/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubDealsIndexRoute = authenticatedHubDealsIndexImport.update(
  {
    id: '/$hub/deals/',
    path: '/$hub/deals/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any,
)

const authenticatedHubContractStatusIndexRoute =
  authenticatedHubContractStatusIndexImport.update({
    id: '/$hub/contract-status/',
    path: '/$hub/contract-status/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubContractQueueIndexRoute =
  authenticatedHubContractQueueIndexImport.update({
    id: '/$hub/contract-queue/',
    path: '/$hub/contract-queue/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubBoardIndexRoute = authenticatedHubBoardIndexImport.update(
  {
    id: '/$hub/board/',
    path: '/$hub/board/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any,
)

const authenticatedHubArchivedDealsIndexRoute =
  authenticatedHubArchivedDealsIndexImport.update({
    id: '/$hub/archived-deals/',
    path: '/$hub/archived-deals/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubAllIndexRoute = authenticatedHubAllIndexImport.update({
  id: '/$hub/all/',
  path: '/$hub/all/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const ApiAuthCallbackSlackIndexRoute = ApiAuthCallbackSlackIndexImport.update({
  id: '/api/auth/callback/slack/',
  path: '/api/auth/callback/slack/',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedTradeShortIdTitleIndexRoute =
  authenticatedTradeShortIdTitleIndexImport.update({
    id: '/trade/$shortId/$title/',
    path: '/trade/$shortId/$title/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubDealShortIdIndexRoute =
  authenticatedHubDealShortIdIndexImport.update({
    id: '/$hub/deal/$shortId/',
    path: '/$hub/deal/$shortId/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedHubDealShortIdTitleIndexRoute =
  authenticatedHubDealShortIdTitleIndexImport.update({
    id: '/$hub/deal/$shortId/$title/',
    path: '/$hub/deal/$shortId/$title/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)': {
      id: '/(authenticated)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/cars': {
      id: '/(authenticated)/cars'
      path: '/cars'
      fullPath: '/cars'
      preLoaderRoute: typeof authenticatedCarsRouteImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/leads': {
      id: '/(authenticated)/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof authenticatedLeadsRouteImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/auth/complete': {
      id: '/auth/complete'
      path: '/auth/complete'
      fullPath: '/auth/complete'
      preLoaderRoute: typeof AuthCompleteImport
      parentRoute: typeof rootRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/about/': {
      id: '/(authenticated)/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof authenticatedAboutIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/appraisals/': {
      id: '/(authenticated)/appraisals/'
      path: '/appraisals'
      fullPath: '/appraisals'
      preLoaderRoute: typeof authenticatedAppraisalsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/components/': {
      id: '/(authenticated)/components/'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof authenticatedComponentsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/connections/': {
      id: '/(authenticated)/connections/'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof authenticatedConnectionsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/hotkeys/': {
      id: '/(authenticated)/hotkeys/'
      path: '/hotkeys'
      fullPath: '/hotkeys'
      preLoaderRoute: typeof authenticatedHotkeysIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/my-tasks/': {
      id: '/(authenticated)/my-tasks/'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof authenticatedMyTasksIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/profile/': {
      id: '/(authenticated)/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof authenticatedProfileIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/tasks/': {
      id: '/(authenticated)/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof authenticatedTasksIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/trades/': {
      id: '/(authenticated)/trades/'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof authenticatedTradesIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/all/': {
      id: '/(authenticated)/$hub/all/'
      path: '/$hub/all'
      fullPath: '/$hub/all'
      preLoaderRoute: typeof authenticatedHubAllIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/archived-deals/': {
      id: '/(authenticated)/$hub/archived-deals/'
      path: '/$hub/archived-deals'
      fullPath: '/$hub/archived-deals'
      preLoaderRoute: typeof authenticatedHubArchivedDealsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/board/': {
      id: '/(authenticated)/$hub/board/'
      path: '/$hub/board'
      fullPath: '/$hub/board'
      preLoaderRoute: typeof authenticatedHubBoardIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/contract-queue/': {
      id: '/(authenticated)/$hub/contract-queue/'
      path: '/$hub/contract-queue'
      fullPath: '/$hub/contract-queue'
      preLoaderRoute: typeof authenticatedHubContractQueueIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/contract-status/': {
      id: '/(authenticated)/$hub/contract-status/'
      path: '/$hub/contract-status'
      fullPath: '/$hub/contract-status'
      preLoaderRoute: typeof authenticatedHubContractStatusIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/deals/': {
      id: '/(authenticated)/$hub/deals/'
      path: '/$hub/deals'
      fullPath: '/$hub/deals'
      preLoaderRoute: typeof authenticatedHubDealsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/delivery-queue/': {
      id: '/(authenticated)/$hub/delivery-queue/'
      path: '/$hub/delivery-queue'
      fullPath: '/$hub/delivery-queue'
      preLoaderRoute: typeof authenticatedHubDeliveryQueueIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/inbox/': {
      id: '/(authenticated)/$hub/inbox/'
      path: '/$hub/inbox'
      fullPath: '/$hub/inbox'
      preLoaderRoute: typeof authenticatedHubInboxIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/logbook/': {
      id: '/(authenticated)/$hub/logbook/'
      path: '/$hub/logbook'
      fullPath: '/$hub/logbook'
      preLoaderRoute: typeof authenticatedHubLogbookIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/my-deals-board/': {
      id: '/(authenticated)/$hub/my-deals-board/'
      path: '/$hub/my-deals-board'
      fullPath: '/$hub/my-deals-board'
      preLoaderRoute: typeof authenticatedHubMyDealsBoardIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/my-deals/': {
      id: '/(authenticated)/$hub/my-deals/'
      path: '/$hub/my-deals'
      fullPath: '/$hub/my-deals'
      preLoaderRoute: typeof authenticatedHubMyDealsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/appraisals/$appraisalId/': {
      id: '/(authenticated)/appraisals/$appraisalId/'
      path: '/appraisals/$appraisalId'
      fullPath: '/appraisals/$appraisalId'
      preLoaderRoute: typeof authenticatedAppraisalsAppraisalIdIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/cars/$listingId/': {
      id: '/(authenticated)/cars/$listingId/'
      path: '/$listingId'
      fullPath: '/cars/$listingId'
      preLoaderRoute: typeof authenticatedCarsListingIdIndexImport
      parentRoute: typeof authenticatedCarsRouteImport
    }
    '/(authenticated)/cars/all/': {
      id: '/(authenticated)/cars/all/'
      path: '/all'
      fullPath: '/cars/all'
      preLoaderRoute: typeof authenticatedCarsAllIndexImport
      parentRoute: typeof authenticatedCarsRouteImport
    }
    '/(authenticated)/cars/available/': {
      id: '/(authenticated)/cars/available/'
      path: '/available'
      fullPath: '/cars/available'
      preLoaderRoute: typeof authenticatedCarsAvailableIndexImport
      parentRoute: typeof authenticatedCarsRouteImport
    }
    '/(authenticated)/cars/pending/': {
      id: '/(authenticated)/cars/pending/'
      path: '/pending'
      fullPath: '/cars/pending'
      preLoaderRoute: typeof authenticatedCarsPendingIndexImport
      parentRoute: typeof authenticatedCarsRouteImport
    }
    '/(authenticated)/cars/sold/': {
      id: '/(authenticated)/cars/sold/'
      path: '/sold'
      fullPath: '/cars/sold'
      preLoaderRoute: typeof authenticatedCarsSoldIndexImport
      parentRoute: typeof authenticatedCarsRouteImport
    }
    '/(authenticated)/trade/$shortId/': {
      id: '/(authenticated)/trade/$shortId/'
      path: '/trade/$shortId'
      fullPath: '/trade/$shortId'
      preLoaderRoute: typeof authenticatedTradeShortIdIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/$hub/deal/$shortId/': {
      id: '/(authenticated)/$hub/deal/$shortId/'
      path: '/$hub/deal/$shortId'
      fullPath: '/$hub/deal/$shortId'
      preLoaderRoute: typeof authenticatedHubDealShortIdIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/trade/$shortId/$title/': {
      id: '/(authenticated)/trade/$shortId/$title/'
      path: '/trade/$shortId/$title'
      fullPath: '/trade/$shortId/$title'
      preLoaderRoute: typeof authenticatedTradeShortIdTitleIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/api/auth/callback/slack/': {
      id: '/api/auth/callback/slack/'
      path: '/api/auth/callback/slack'
      fullPath: '/api/auth/callback/slack'
      preLoaderRoute: typeof ApiAuthCallbackSlackIndexImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/$hub/deal/$shortId/$title/': {
      id: '/(authenticated)/$hub/deal/$shortId/$title/'
      path: '/$hub/deal/$shortId/$title'
      fullPath: '/$hub/deal/$shortId/$title'
      preLoaderRoute: typeof authenticatedHubDealShortIdTitleIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
  }
}

// Create and export the route tree

interface authenticatedCarsRouteRouteChildren {
  authenticatedCarsListingIdIndexRoute: typeof authenticatedCarsListingIdIndexRoute
  authenticatedCarsAllIndexRoute: typeof authenticatedCarsAllIndexRoute
  authenticatedCarsAvailableIndexRoute: typeof authenticatedCarsAvailableIndexRoute
  authenticatedCarsPendingIndexRoute: typeof authenticatedCarsPendingIndexRoute
  authenticatedCarsSoldIndexRoute: typeof authenticatedCarsSoldIndexRoute
}

const authenticatedCarsRouteRouteChildren: authenticatedCarsRouteRouteChildren =
  {
    authenticatedCarsListingIdIndexRoute: authenticatedCarsListingIdIndexRoute,
    authenticatedCarsAllIndexRoute: authenticatedCarsAllIndexRoute,
    authenticatedCarsAvailableIndexRoute: authenticatedCarsAvailableIndexRoute,
    authenticatedCarsPendingIndexRoute: authenticatedCarsPendingIndexRoute,
    authenticatedCarsSoldIndexRoute: authenticatedCarsSoldIndexRoute,
  }

const authenticatedCarsRouteRouteWithChildren =
  authenticatedCarsRouteRoute._addFileChildren(
    authenticatedCarsRouteRouteChildren,
  )

interface authenticatedRouteRouteChildren {
  authenticatedCarsRouteRoute: typeof authenticatedCarsRouteRouteWithChildren
  authenticatedLeadsRouteRoute: typeof authenticatedLeadsRouteRoute
  authenticatedAboutIndexRoute: typeof authenticatedAboutIndexRoute
  authenticatedAppraisalsIndexRoute: typeof authenticatedAppraisalsIndexRoute
  authenticatedComponentsIndexRoute: typeof authenticatedComponentsIndexRoute
  authenticatedConnectionsIndexRoute: typeof authenticatedConnectionsIndexRoute
  authenticatedHotkeysIndexRoute: typeof authenticatedHotkeysIndexRoute
  authenticatedMyTasksIndexRoute: typeof authenticatedMyTasksIndexRoute
  authenticatedProfileIndexRoute: typeof authenticatedProfileIndexRoute
  authenticatedTasksIndexRoute: typeof authenticatedTasksIndexRoute
  authenticatedTradesIndexRoute: typeof authenticatedTradesIndexRoute
  authenticatedHubAllIndexRoute: typeof authenticatedHubAllIndexRoute
  authenticatedHubArchivedDealsIndexRoute: typeof authenticatedHubArchivedDealsIndexRoute
  authenticatedHubBoardIndexRoute: typeof authenticatedHubBoardIndexRoute
  authenticatedHubContractQueueIndexRoute: typeof authenticatedHubContractQueueIndexRoute
  authenticatedHubContractStatusIndexRoute: typeof authenticatedHubContractStatusIndexRoute
  authenticatedHubDealsIndexRoute: typeof authenticatedHubDealsIndexRoute
  authenticatedHubDeliveryQueueIndexRoute: typeof authenticatedHubDeliveryQueueIndexRoute
  authenticatedHubInboxIndexRoute: typeof authenticatedHubInboxIndexRoute
  authenticatedHubLogbookIndexRoute: typeof authenticatedHubLogbookIndexRoute
  authenticatedHubMyDealsBoardIndexRoute: typeof authenticatedHubMyDealsBoardIndexRoute
  authenticatedHubMyDealsIndexRoute: typeof authenticatedHubMyDealsIndexRoute
  authenticatedAppraisalsAppraisalIdIndexRoute: typeof authenticatedAppraisalsAppraisalIdIndexRoute
  authenticatedTradeShortIdIndexRoute: typeof authenticatedTradeShortIdIndexRoute
  authenticatedHubDealShortIdIndexRoute: typeof authenticatedHubDealShortIdIndexRoute
  authenticatedTradeShortIdTitleIndexRoute: typeof authenticatedTradeShortIdTitleIndexRoute
  authenticatedHubDealShortIdTitleIndexRoute: typeof authenticatedHubDealShortIdTitleIndexRoute
}

const authenticatedRouteRouteChildren: authenticatedRouteRouteChildren = {
  authenticatedCarsRouteRoute: authenticatedCarsRouteRouteWithChildren,
  authenticatedLeadsRouteRoute: authenticatedLeadsRouteRoute,
  authenticatedAboutIndexRoute: authenticatedAboutIndexRoute,
  authenticatedAppraisalsIndexRoute: authenticatedAppraisalsIndexRoute,
  authenticatedComponentsIndexRoute: authenticatedComponentsIndexRoute,
  authenticatedConnectionsIndexRoute: authenticatedConnectionsIndexRoute,
  authenticatedHotkeysIndexRoute: authenticatedHotkeysIndexRoute,
  authenticatedMyTasksIndexRoute: authenticatedMyTasksIndexRoute,
  authenticatedProfileIndexRoute: authenticatedProfileIndexRoute,
  authenticatedTasksIndexRoute: authenticatedTasksIndexRoute,
  authenticatedTradesIndexRoute: authenticatedTradesIndexRoute,
  authenticatedHubAllIndexRoute: authenticatedHubAllIndexRoute,
  authenticatedHubArchivedDealsIndexRoute:
    authenticatedHubArchivedDealsIndexRoute,
  authenticatedHubBoardIndexRoute: authenticatedHubBoardIndexRoute,
  authenticatedHubContractQueueIndexRoute:
    authenticatedHubContractQueueIndexRoute,
  authenticatedHubContractStatusIndexRoute:
    authenticatedHubContractStatusIndexRoute,
  authenticatedHubDealsIndexRoute: authenticatedHubDealsIndexRoute,
  authenticatedHubDeliveryQueueIndexRoute:
    authenticatedHubDeliveryQueueIndexRoute,
  authenticatedHubInboxIndexRoute: authenticatedHubInboxIndexRoute,
  authenticatedHubLogbookIndexRoute: authenticatedHubLogbookIndexRoute,
  authenticatedHubMyDealsBoardIndexRoute:
    authenticatedHubMyDealsBoardIndexRoute,
  authenticatedHubMyDealsIndexRoute: authenticatedHubMyDealsIndexRoute,
  authenticatedAppraisalsAppraisalIdIndexRoute:
    authenticatedAppraisalsAppraisalIdIndexRoute,
  authenticatedTradeShortIdIndexRoute: authenticatedTradeShortIdIndexRoute,
  authenticatedHubDealShortIdIndexRoute: authenticatedHubDealShortIdIndexRoute,
  authenticatedTradeShortIdTitleIndexRoute:
    authenticatedTradeShortIdTitleIndexRoute,
  authenticatedHubDealShortIdTitleIndexRoute:
    authenticatedHubDealShortIdTitleIndexRoute,
}

const authenticatedRouteRouteWithChildren =
  authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof authenticatedRouteRouteWithChildren
  '/cars': typeof authenticatedCarsRouteRouteWithChildren
  '/leads': typeof authenticatedLeadsRouteRoute
  '/auth/complete': typeof AuthCompleteRoute
  '/auth': typeof AuthIndexRoute
  '/about': typeof authenticatedAboutIndexRoute
  '/appraisals': typeof authenticatedAppraisalsIndexRoute
  '/components': typeof authenticatedComponentsIndexRoute
  '/connections': typeof authenticatedConnectionsIndexRoute
  '/hotkeys': typeof authenticatedHotkeysIndexRoute
  '/my-tasks': typeof authenticatedMyTasksIndexRoute
  '/profile': typeof authenticatedProfileIndexRoute
  '/tasks': typeof authenticatedTasksIndexRoute
  '/trades': typeof authenticatedTradesIndexRoute
  '/$hub/all': typeof authenticatedHubAllIndexRoute
  '/$hub/archived-deals': typeof authenticatedHubArchivedDealsIndexRoute
  '/$hub/board': typeof authenticatedHubBoardIndexRoute
  '/$hub/contract-queue': typeof authenticatedHubContractQueueIndexRoute
  '/$hub/contract-status': typeof authenticatedHubContractStatusIndexRoute
  '/$hub/deals': typeof authenticatedHubDealsIndexRoute
  '/$hub/delivery-queue': typeof authenticatedHubDeliveryQueueIndexRoute
  '/$hub/inbox': typeof authenticatedHubInboxIndexRoute
  '/$hub/logbook': typeof authenticatedHubLogbookIndexRoute
  '/$hub/my-deals-board': typeof authenticatedHubMyDealsBoardIndexRoute
  '/$hub/my-deals': typeof authenticatedHubMyDealsIndexRoute
  '/appraisals/$appraisalId': typeof authenticatedAppraisalsAppraisalIdIndexRoute
  '/cars/$listingId': typeof authenticatedCarsListingIdIndexRoute
  '/cars/all': typeof authenticatedCarsAllIndexRoute
  '/cars/available': typeof authenticatedCarsAvailableIndexRoute
  '/cars/pending': typeof authenticatedCarsPendingIndexRoute
  '/cars/sold': typeof authenticatedCarsSoldIndexRoute
  '/trade/$shortId': typeof authenticatedTradeShortIdIndexRoute
  '/$hub/deal/$shortId': typeof authenticatedHubDealShortIdIndexRoute
  '/trade/$shortId/$title': typeof authenticatedTradeShortIdTitleIndexRoute
  '/api/auth/callback/slack': typeof ApiAuthCallbackSlackIndexRoute
  '/$hub/deal/$shortId/$title': typeof authenticatedHubDealShortIdTitleIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof authenticatedRouteRouteWithChildren
  '/cars': typeof authenticatedCarsRouteRouteWithChildren
  '/leads': typeof authenticatedLeadsRouteRoute
  '/auth/complete': typeof AuthCompleteRoute
  '/auth': typeof AuthIndexRoute
  '/about': typeof authenticatedAboutIndexRoute
  '/appraisals': typeof authenticatedAppraisalsIndexRoute
  '/components': typeof authenticatedComponentsIndexRoute
  '/connections': typeof authenticatedConnectionsIndexRoute
  '/hotkeys': typeof authenticatedHotkeysIndexRoute
  '/my-tasks': typeof authenticatedMyTasksIndexRoute
  '/profile': typeof authenticatedProfileIndexRoute
  '/tasks': typeof authenticatedTasksIndexRoute
  '/trades': typeof authenticatedTradesIndexRoute
  '/$hub/all': typeof authenticatedHubAllIndexRoute
  '/$hub/archived-deals': typeof authenticatedHubArchivedDealsIndexRoute
  '/$hub/board': typeof authenticatedHubBoardIndexRoute
  '/$hub/contract-queue': typeof authenticatedHubContractQueueIndexRoute
  '/$hub/contract-status': typeof authenticatedHubContractStatusIndexRoute
  '/$hub/deals': typeof authenticatedHubDealsIndexRoute
  '/$hub/delivery-queue': typeof authenticatedHubDeliveryQueueIndexRoute
  '/$hub/inbox': typeof authenticatedHubInboxIndexRoute
  '/$hub/logbook': typeof authenticatedHubLogbookIndexRoute
  '/$hub/my-deals-board': typeof authenticatedHubMyDealsBoardIndexRoute
  '/$hub/my-deals': typeof authenticatedHubMyDealsIndexRoute
  '/appraisals/$appraisalId': typeof authenticatedAppraisalsAppraisalIdIndexRoute
  '/cars/$listingId': typeof authenticatedCarsListingIdIndexRoute
  '/cars/all': typeof authenticatedCarsAllIndexRoute
  '/cars/available': typeof authenticatedCarsAvailableIndexRoute
  '/cars/pending': typeof authenticatedCarsPendingIndexRoute
  '/cars/sold': typeof authenticatedCarsSoldIndexRoute
  '/trade/$shortId': typeof authenticatedTradeShortIdIndexRoute
  '/$hub/deal/$shortId': typeof authenticatedHubDealShortIdIndexRoute
  '/trade/$shortId/$title': typeof authenticatedTradeShortIdTitleIndexRoute
  '/api/auth/callback/slack': typeof ApiAuthCallbackSlackIndexRoute
  '/$hub/deal/$shortId/$title': typeof authenticatedHubDealShortIdTitleIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/(authenticated)': typeof authenticatedRouteRouteWithChildren
  '/(authenticated)/cars': typeof authenticatedCarsRouteRouteWithChildren
  '/(authenticated)/leads': typeof authenticatedLeadsRouteRoute
  '/auth/complete': typeof AuthCompleteRoute
  '/auth/': typeof AuthIndexRoute
  '/(authenticated)/about/': typeof authenticatedAboutIndexRoute
  '/(authenticated)/appraisals/': typeof authenticatedAppraisalsIndexRoute
  '/(authenticated)/components/': typeof authenticatedComponentsIndexRoute
  '/(authenticated)/connections/': typeof authenticatedConnectionsIndexRoute
  '/(authenticated)/hotkeys/': typeof authenticatedHotkeysIndexRoute
  '/(authenticated)/my-tasks/': typeof authenticatedMyTasksIndexRoute
  '/(authenticated)/profile/': typeof authenticatedProfileIndexRoute
  '/(authenticated)/tasks/': typeof authenticatedTasksIndexRoute
  '/(authenticated)/trades/': typeof authenticatedTradesIndexRoute
  '/(authenticated)/$hub/all/': typeof authenticatedHubAllIndexRoute
  '/(authenticated)/$hub/archived-deals/': typeof authenticatedHubArchivedDealsIndexRoute
  '/(authenticated)/$hub/board/': typeof authenticatedHubBoardIndexRoute
  '/(authenticated)/$hub/contract-queue/': typeof authenticatedHubContractQueueIndexRoute
  '/(authenticated)/$hub/contract-status/': typeof authenticatedHubContractStatusIndexRoute
  '/(authenticated)/$hub/deals/': typeof authenticatedHubDealsIndexRoute
  '/(authenticated)/$hub/delivery-queue/': typeof authenticatedHubDeliveryQueueIndexRoute
  '/(authenticated)/$hub/inbox/': typeof authenticatedHubInboxIndexRoute
  '/(authenticated)/$hub/logbook/': typeof authenticatedHubLogbookIndexRoute
  '/(authenticated)/$hub/my-deals-board/': typeof authenticatedHubMyDealsBoardIndexRoute
  '/(authenticated)/$hub/my-deals/': typeof authenticatedHubMyDealsIndexRoute
  '/(authenticated)/appraisals/$appraisalId/': typeof authenticatedAppraisalsAppraisalIdIndexRoute
  '/(authenticated)/cars/$listingId/': typeof authenticatedCarsListingIdIndexRoute
  '/(authenticated)/cars/all/': typeof authenticatedCarsAllIndexRoute
  '/(authenticated)/cars/available/': typeof authenticatedCarsAvailableIndexRoute
  '/(authenticated)/cars/pending/': typeof authenticatedCarsPendingIndexRoute
  '/(authenticated)/cars/sold/': typeof authenticatedCarsSoldIndexRoute
  '/(authenticated)/trade/$shortId/': typeof authenticatedTradeShortIdIndexRoute
  '/(authenticated)/$hub/deal/$shortId/': typeof authenticatedHubDealShortIdIndexRoute
  '/(authenticated)/trade/$shortId/$title/': typeof authenticatedTradeShortIdTitleIndexRoute
  '/api/auth/callback/slack/': typeof ApiAuthCallbackSlackIndexRoute
  '/(authenticated)/$hub/deal/$shortId/$title/': typeof authenticatedHubDealShortIdTitleIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cars'
    | '/leads'
    | '/auth/complete'
    | '/auth'
    | '/about'
    | '/appraisals'
    | '/components'
    | '/connections'
    | '/hotkeys'
    | '/my-tasks'
    | '/profile'
    | '/tasks'
    | '/trades'
    | '/$hub/all'
    | '/$hub/archived-deals'
    | '/$hub/board'
    | '/$hub/contract-queue'
    | '/$hub/contract-status'
    | '/$hub/deals'
    | '/$hub/delivery-queue'
    | '/$hub/inbox'
    | '/$hub/logbook'
    | '/$hub/my-deals-board'
    | '/$hub/my-deals'
    | '/appraisals/$appraisalId'
    | '/cars/$listingId'
    | '/cars/all'
    | '/cars/available'
    | '/cars/pending'
    | '/cars/sold'
    | '/trade/$shortId'
    | '/$hub/deal/$shortId'
    | '/trade/$shortId/$title'
    | '/api/auth/callback/slack'
    | '/$hub/deal/$shortId/$title'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cars'
    | '/leads'
    | '/auth/complete'
    | '/auth'
    | '/about'
    | '/appraisals'
    | '/components'
    | '/connections'
    | '/hotkeys'
    | '/my-tasks'
    | '/profile'
    | '/tasks'
    | '/trades'
    | '/$hub/all'
    | '/$hub/archived-deals'
    | '/$hub/board'
    | '/$hub/contract-queue'
    | '/$hub/contract-status'
    | '/$hub/deals'
    | '/$hub/delivery-queue'
    | '/$hub/inbox'
    | '/$hub/logbook'
    | '/$hub/my-deals-board'
    | '/$hub/my-deals'
    | '/appraisals/$appraisalId'
    | '/cars/$listingId'
    | '/cars/all'
    | '/cars/available'
    | '/cars/pending'
    | '/cars/sold'
    | '/trade/$shortId'
    | '/$hub/deal/$shortId'
    | '/trade/$shortId/$title'
    | '/api/auth/callback/slack'
    | '/$hub/deal/$shortId/$title'
  id:
    | '__root__'
    | '/'
    | '/(authenticated)'
    | '/(authenticated)/cars'
    | '/(authenticated)/leads'
    | '/auth/complete'
    | '/auth/'
    | '/(authenticated)/about/'
    | '/(authenticated)/appraisals/'
    | '/(authenticated)/components/'
    | '/(authenticated)/connections/'
    | '/(authenticated)/hotkeys/'
    | '/(authenticated)/my-tasks/'
    | '/(authenticated)/profile/'
    | '/(authenticated)/tasks/'
    | '/(authenticated)/trades/'
    | '/(authenticated)/$hub/all/'
    | '/(authenticated)/$hub/archived-deals/'
    | '/(authenticated)/$hub/board/'
    | '/(authenticated)/$hub/contract-queue/'
    | '/(authenticated)/$hub/contract-status/'
    | '/(authenticated)/$hub/deals/'
    | '/(authenticated)/$hub/delivery-queue/'
    | '/(authenticated)/$hub/inbox/'
    | '/(authenticated)/$hub/logbook/'
    | '/(authenticated)/$hub/my-deals-board/'
    | '/(authenticated)/$hub/my-deals/'
    | '/(authenticated)/appraisals/$appraisalId/'
    | '/(authenticated)/cars/$listingId/'
    | '/(authenticated)/cars/all/'
    | '/(authenticated)/cars/available/'
    | '/(authenticated)/cars/pending/'
    | '/(authenticated)/cars/sold/'
    | '/(authenticated)/trade/$shortId/'
    | '/(authenticated)/$hub/deal/$shortId/'
    | '/(authenticated)/trade/$shortId/$title/'
    | '/api/auth/callback/slack/'
    | '/(authenticated)/$hub/deal/$shortId/$title/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authenticatedRouteRoute: typeof authenticatedRouteRouteWithChildren
  AuthCompleteRoute: typeof AuthCompleteRoute
  AuthIndexRoute: typeof AuthIndexRoute
  ApiAuthCallbackSlackIndexRoute: typeof ApiAuthCallbackSlackIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authenticatedRouteRoute: authenticatedRouteRouteWithChildren,
  AuthCompleteRoute: AuthCompleteRoute,
  AuthIndexRoute: AuthIndexRoute,
  ApiAuthCallbackSlackIndexRoute: ApiAuthCallbackSlackIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(authenticated)",
        "/auth/complete",
        "/auth/",
        "/api/auth/callback/slack/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(authenticated)": {
      "filePath": "(authenticated)/route.tsx",
      "children": [
        "/(authenticated)/cars",
        "/(authenticated)/leads",
        "/(authenticated)/about/",
        "/(authenticated)/appraisals/",
        "/(authenticated)/components/",
        "/(authenticated)/connections/",
        "/(authenticated)/hotkeys/",
        "/(authenticated)/my-tasks/",
        "/(authenticated)/profile/",
        "/(authenticated)/tasks/",
        "/(authenticated)/trades/",
        "/(authenticated)/$hub/all/",
        "/(authenticated)/$hub/archived-deals/",
        "/(authenticated)/$hub/board/",
        "/(authenticated)/$hub/contract-queue/",
        "/(authenticated)/$hub/contract-status/",
        "/(authenticated)/$hub/deals/",
        "/(authenticated)/$hub/delivery-queue/",
        "/(authenticated)/$hub/inbox/",
        "/(authenticated)/$hub/logbook/",
        "/(authenticated)/$hub/my-deals-board/",
        "/(authenticated)/$hub/my-deals/",
        "/(authenticated)/appraisals/$appraisalId/",
        "/(authenticated)/trade/$shortId/",
        "/(authenticated)/$hub/deal/$shortId/",
        "/(authenticated)/trade/$shortId/$title/",
        "/(authenticated)/$hub/deal/$shortId/$title/"
      ]
    },
    "/(authenticated)/cars": {
      "filePath": "(authenticated)/cars/route.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/cars/$listingId/",
        "/(authenticated)/cars/all/",
        "/(authenticated)/cars/available/",
        "/(authenticated)/cars/pending/",
        "/(authenticated)/cars/sold/"
      ]
    },
    "/(authenticated)/leads": {
      "filePath": "(authenticated)/leads/route.tsx",
      "parent": "/(authenticated)"
    },
    "/auth/complete": {
      "filePath": "auth/complete.tsx"
    },
    "/auth/": {
      "filePath": "auth/index.tsx"
    },
    "/(authenticated)/about/": {
      "filePath": "(authenticated)/about/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/appraisals/": {
      "filePath": "(authenticated)/appraisals/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/components/": {
      "filePath": "(authenticated)/components/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/connections/": {
      "filePath": "(authenticated)/connections/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/hotkeys/": {
      "filePath": "(authenticated)/hotkeys/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/my-tasks/": {
      "filePath": "(authenticated)/my-tasks/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/profile/": {
      "filePath": "(authenticated)/profile/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/tasks/": {
      "filePath": "(authenticated)/tasks/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/trades/": {
      "filePath": "(authenticated)/trades/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/all/": {
      "filePath": "(authenticated)/$hub/all/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/archived-deals/": {
      "filePath": "(authenticated)/$hub/archived-deals/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/board/": {
      "filePath": "(authenticated)/$hub/board/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/contract-queue/": {
      "filePath": "(authenticated)/$hub/contract-queue/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/contract-status/": {
      "filePath": "(authenticated)/$hub/contract-status/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/deals/": {
      "filePath": "(authenticated)/$hub/deals/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/delivery-queue/": {
      "filePath": "(authenticated)/$hub/delivery-queue/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/inbox/": {
      "filePath": "(authenticated)/$hub/inbox/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/logbook/": {
      "filePath": "(authenticated)/$hub/logbook/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/my-deals-board/": {
      "filePath": "(authenticated)/$hub/my-deals-board/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/my-deals/": {
      "filePath": "(authenticated)/$hub/my-deals/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/appraisals/$appraisalId/": {
      "filePath": "(authenticated)/appraisals/$appraisalId/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/cars/$listingId/": {
      "filePath": "(authenticated)/cars/$listingId/index.tsx",
      "parent": "/(authenticated)/cars"
    },
    "/(authenticated)/cars/all/": {
      "filePath": "(authenticated)/cars/all/index.tsx",
      "parent": "/(authenticated)/cars"
    },
    "/(authenticated)/cars/available/": {
      "filePath": "(authenticated)/cars/available/index.tsx",
      "parent": "/(authenticated)/cars"
    },
    "/(authenticated)/cars/pending/": {
      "filePath": "(authenticated)/cars/pending/index.tsx",
      "parent": "/(authenticated)/cars"
    },
    "/(authenticated)/cars/sold/": {
      "filePath": "(authenticated)/cars/sold/index.tsx",
      "parent": "/(authenticated)/cars"
    },
    "/(authenticated)/trade/$shortId/": {
      "filePath": "(authenticated)/trade/$shortId/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$hub/deal/$shortId/": {
      "filePath": "(authenticated)/$hub/deal/$shortId/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/trade/$shortId/$title/": {
      "filePath": "(authenticated)/trade/$shortId/$title/index.tsx",
      "parent": "/(authenticated)"
    },
    "/api/auth/callback/slack/": {
      "filePath": "api/auth/callback/slack/index.tsx"
    },
    "/(authenticated)/$hub/deal/$shortId/$title/": {
      "filePath": "(authenticated)/$hub/deal/$shortId/$title/index.tsx",
      "parent": "/(authenticated)"
    }
  }
}
ROUTE_MANIFEST_END */
